<template>
  <div class="audience-customers p-2">
     <CustomerTable :exclude-search-fields="['category_uuids', 'activityDateRange', 'interest_category_uuids']"
        :exclude-columns="['activity', 'interest_categories']" selectable :hideActions="true"
        export-permission-name="export_customer" enable-export :exportAttributes="exportAttributes"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import CustomerTable from "@/modules/customer/CustomerTable";
  import i18n from "@/shared/i18n";
  import {SOURCE_AUDIENCE_CUSTOMERS} from "@/modules/constants";

  const {mapState: customerMapState, mapActions} = createNamespacedHelpers('customer');
  const {mapState} = createNamespacedHelpers('marketing/audience');

  export default {
    name: "AudienceCustomers",
    components: {CustomerTable},
    computed: {
      ...mapState({
        audience: state => state.view.audience
      }),
      ...customerMapState({
        toggleColumns: state => state.tableData[state.tableSource].toggleColumns,
      }),
      exportAttributes() {
        let mapping = {
          no: 'customer_no',
          full_name: 'display_name',
          address: 'display_billing_address',
          shipping_address: 'display_shipping_address',
          account_managers: 'account_managers[[display_name]]',
          interest_categories: 'interest_categories[[active_translation_name]]',
          trust_level: 'trust_level_display_name',
          personal_identification_number: 'identification.personal_identification_number',
          document_type: 'identification.document_type',
          document_number: 'identification.document_number',
          document_issue_date: 'identification.document_issue_date',
          document_expiry_date: 'identification.document_expiry_date',
          date_of_birth: 'identification.date_of_birth',
          citizenship_code: 'identification.citizenship_code',
          residency_code: 'identification.residency_code',
          country_of_birth_code: 'identification.country_of_birth_code',
          place_of_issue: 'identification.place_of_issue',
          company_reg_number: 'identification.company_reg_number',
        }
        let cols = {};
        for (let col of this.toggleColumns.defaultFields) {
          cols[mapping[col] || col] = i18n.t(col.split('_').map(x=>x.replace(/^./, x[0].toUpperCase())).join(' '));
        }
        return cols;
      }
    },
    methods: {
      ...mapActions(['updateTableSource']),
    },
    async beforeMount() {
      await this.updateTableSource({
        source: SOURCE_AUDIENCE_CUSTOMERS,
        extraFilters: {audience_uuid: this.audience.uuid},
      });
    }
  }
</script>

<style scoped lang="scss">
  @import "./../scss/variables";
</style>
